import { setApiTokenHeader } from "./services/http-client";

let cachedCRMSetting = null;
export const X_API_KEY = 'aLC0zEu7p6hAiKDrxBSfoe5PITqVIFDZSd4zGmwQQSyZSOoYXLVZFDgJyvL8HkM1';
const BUILDING_API_TOKEN = 'Jr9ORHkgSCav399MX0qVj8nkzQXLIw8X4RJCLpUd';
function mapToLegacySettings(data) {
	console.log("Mapping CRM settings to legacy format:", data);
	const { crm_setting, user, company, api, navigation, meta, features } = data;
	return {
		Logo_IMG: crm_setting.logo_img,
		is_Action_url: crm_setting.is_action_url,
		is_CRM: crm_setting.is_crm,

		login_user_id: user?.id || crm_setting.login_user_id,
		referral_id: crm_setting.referral_id,
		form_action: crm_setting.form_action,

		is_Edit: crm_setting.is_edit === "true" || crm_setting.is_edit === true,
		is_quote_Edit: crm_setting.is_quote_edit,

		module_id_string: crm_setting.module_id_string,
		sub_module: crm_setting.sub_module,
		sub_module_id: crm_setting.sub_module_id,

		is_module_id: crm_setting.module_id,
		is_module_name: crm_setting.module_name,

		duplicate_module: crm_setting.duplicate_module,
		web_url: crm_setting.web_url,
		selected_sub_module: crm_setting.selected_sub_module,

		company_name: company?.name || crm_setting.company_name,
		gTag: crm_setting.g_tag,
		orderColor: crm_setting.order_colour,

		is_loggedin: user?.is_loggedin || crm_setting.is_logged_id,

		price_api_url: api?.pricing_url,

		header_key: {
			"x-api-key": BUILDING_API_TOKEN
		},
		order_now: crm_setting.order_now,
		BuisnessName: crm_setting.business_name,

		crm_product_id: String(crm_setting.crm_product_id),

		api_token: crm_setting?.api_token ?? BUILDING_API_TOKEN,
		parent_api_token: crm_setting?.parent_api_token ?? BUILDING_API_TOKEN,

		stripe_detail: {
			enabled: crm_setting?.stripe_detail?.enabled,
			testmode: crm_setting?.stripe_detail?.test_mode,
			test_publishable_key: crm_setting?.stripe_detail?.test_publishable_key,
			test_secret_key: crm_setting?.stripe_detail?.test_secret_key,
			publishable_key: crm_setting?.stripe_detail?.publishable_key,
			secret_key: crm_setting?.stripe_detail?.secret_key
		},

		api_post_url: crm_setting.api_post_url,

		email: user?.email,
		phone_number: company?.phone_number,

		source: meta?.source,
		form: meta?.form,
		page: meta?.page,

		menu_address: company?.dealer_address,
		main_domain_url: crm_setting.main_domain_url,

		pre_quote_form: crm_setting.pre_quote_form,
		is_zipcode_screen: crm_setting.is_zipcode_screen,

		navigation_url: buildNavigationUrls(crm_setting.web_url),

		is_klink_generated: crm_setting.is_klink_generated,
		has_customer_permission: features?.has_customer_permission,

		is_CRM_V4: crm_setting.is_crm_v4,
		latest_api_url: api?.latest_api_url
	};
}

export function getCRMSettings() {
	if (cachedCRMSetting) return cachedCRMSetting;

	if (window.CRMSettings?.crm_setting) {
		cachedCRMSetting = mapToLegacySettings(window.CRMSettings);
		window.crmSetting = cachedCRMSetting;
		return cachedCRMSetting;
	}
	if (window.crmSetting) {
		cachedCRMSetting = window.crmSetting;
		return cachedCRMSetting;
	}
	cachedCRMSetting = {
		...defaultCRMSetting,
		navigation_url: buildNavigationUrls(defaultCRMSetting.web_url)
	};

	return cachedCRMSetting;
}

const defaultCRMSetting = {
	Logo_IMG: "logo.svg",
	is_Action_url: "quotes",
	is_CRM: true,
	referral_id: "AQ40JK",
	login_user_id: "OVJXU2VRWlJrS0taSlN1YXJVcm5KQT09",
	referral_id: "WLDNSC",
	form_action: "create",
	is_Edit: false,
	is_quote_Edit: 0,
	module_id_string: "",
	sub_module: "",
	sub_module_id: "",
	is_module_id: "bEJWR2JXMnJ0bzhkakVLbnU3c3hLQT09",
	is_module_name: "quote",
	duplicate_module: "",
	web_url: "https://pre.senseicrm.com",
	selected_sub_module: "0",
	company_name: "Cibirix Company",
	gTag: false,
	orderColor: "#D12029",
	is_loggedin: true,
	price_api_url: "https://preapi.senseicrm.com/",
	header_key: {
		"x-api-key": BUILDING_API_TOKEN
	},
	order_now: true,
	BuisnessName: "Sensei CRM",
	crm_product_id: "22",
	api_token: BUILDING_API_TOKEN,
	parent_api_token: BUILDING_API_TOKEN,
	stripe_detail: {
		enabled: "yes",
		testmode: "yes",
		test_publishable_key: "pk_test_rdFjxhfdgUp51mDhmHz2VjTL",
		test_secret_key: "",
		publishable_key: "",
		secret_key: ""
	},
	api_post_url: "https://pre.senseicrm.com",
	email: "harish@cibirix.com",
	phone_number: "(989) 898-9899",
	source: "https://staging.senseicrm.com",
	form: "Quote",
	page: "https://staging.senseicrm.com",
	menu_address: "271 OLD Hwy 99W Maxwell, CA 95955",
	main_domain_url: "vaibhavcibirix.com", //vaibhavcibirix.com
	pre_quote_form: false,
	is_zipcode_screen: false,
	is_klink_generated: 0,
	has_customer_permission: "1",
	is_CRM_V4: true,
	latest_api_url: "https://staging-api.senseicrm.com/"
};
function buildNavigationUrls(baseUrl) {
	return {
		lead: `${baseUrl}/leads`,
		quote: `${baseUrl}/quotes`,
		my_account: `${baseUrl}/settings/personal`,
		post: `${baseUrl}/posts-sensei/R3RTZGJmYzBLa2J3VDBseUtCMGwrdz09`,
		my_team: `${baseUrl}/users`,
		my_subscription: `${baseUrl}/subscriptions`,
		logout: `${baseUrl}/logout`,
		report_error: `${baseUrl}/tickets`
	};
}
// export const setToken = (token) => {
// 	if (!token) {
// 		console.error("Token is required to set API token in CRM settings.");
// 		return;
// 	}
// 	const crmSettings = getCRMSettings();
// 	// crmSettings.api_token = API_TOKEN;
// 	// crmSettings.parent_api_token = API_TOKEN;
// 	// crmSettings.header_key["x-api-key"] = token;
// 	window.crmSetting = crmSettings;
// 	cachedCRMSetting = crmSettings;
// };

export const setApiKey = () => {
	const crmSettings = getCRMSettings();
	crmSettings["api-key"] = X_API_KEY;
	window.crmSetting = crmSettings;
	cachedCRMSetting = crmSettings;
	setApiTokenHeader();
	console.log("CRM settings have been set:", crmSettings.api_token);
};